import { Backdrop } from "@mui/material";
import Types from "prop-types";
import React from "react";
import BeatLoader from "react-spinners/BeatLoader";

const Loading = ({ loading = false }) => {
  return (
    <Backdrop sx={{ color: "#fff", zIndex: 99999 }} open={loading}>
      <div className="react-spinner">
        <BeatLoader size={20} color="#36D7B7" loading={loading} />
      </div>
    </Backdrop>
  );
};

Loading.propTypes = {
  loading: Types.bool,
};

export default Loading;
